import { STORE } from './schema';

/**
 * Schema migrations.
 *
 * Each step upgrades from one version to the next and is applied in order, so a save from
 * any previously released version can be brought forward. Migrations run inside the
 * `upgradeneeded` transaction; they must not use async APIs.
 */

export interface Migration {
  readonly toVersion: number;
  readonly describe: string;
  apply(database: IDBDatabase, transaction: IDBTransaction | null): void;
}

export const MIGRATIONS: readonly Migration[] = [
  {
    toVersion: 1,
    describe: 'initial stores',
    apply(database) {
      for (const store of Object.values(STORE)) {
        if (!database.objectStoreNames.contains(store)) {
          database.createObjectStore(store);
        }
      }
    },
  },
];

export function runMigrations(
  database: IDBDatabase,
  transaction: IDBTransaction | null,
  oldVersion: number,
  newVersion: number,
): void {
  for (const migration of MIGRATIONS) {
    if (migration.toVersion > oldVersion && migration.toVersion <= newVersion) {
      migration.apply(database, transaction);
    }
  }
}
